import * as React from 'react';
import { Banner } from 'labxchange-client';
import { Icon } from 'ui/components';
import { RichText } from 'elements/components/RichText';
import { sanitizeConfigOptions } from '@labxchange/util-sanitization';
import { PolicyAndTermsUpdatesBannerId } from '../../actions';
import { intl } from 'i18n';
import messages from '../../displayMessages';

interface BannerItemProps {
    banner: Readonly<Banner>;
    dismiss: (banner: Banner) => void;
    className?: string;
}

export class BannerItem extends React.Component<BannerItemProps> {
    public render() {
        const {banner, className} = this.props;

        return (
            <div className={`banner-item ${className}`}>
                <div className='banner-content'>
                    <h4>
                        <RichText
                            innerHtml={banner.content}
                            sanitizeConfig={sanitizeConfigOptions.UnsafeBannerHTML}
                        />
                    </h4>
                </div>
                {!banner.disableDismiss &&
                  <button
                      className='unstyled'
                      onClick={() => this.dismiss(banner)}
                  >
                      <span className='close-icon'>
                          <Icon name='x' zoom='14' />
                      </span>
                  </button>
                }
                {banner.id === PolicyAndTermsUpdatesBannerId &&
                  <button
                    className='accept-terms'
                    onClick={() => this.dismiss(banner)}
                  >
                      {intl.formatMessage(messages.acceptTermsButton)}
                  </button>
                }
            </div>
        );
    }

    private dismiss = (banner?: Banner) => {
        if (banner?.id !== undefined) {
            this.props.dismiss(banner);
        }
    }
}
